/**
 * Chemins du SPA où un visiteur peut naviguer sans session valide.
 * Réutilisé par la bulle support et par l’intercepteur API (401 → pas de redirection violente vers /login).
 */
const EXACT_PUBLIC_PATHS = new Set([
  '/',
  '/pricing',
  '/features',
  '/about',
  '/contact',
  '/accessibility',
  '/blog',
  '/store',
  '/use-cases',
  '/partners',
  '/privacy',
  '/terms',
  '/cookies',
]);

const AUTH_PATHS = new Set([
  '/login',
  '/register',
  '/establishment/register',
  '/forgot-password',
  '/reset-password',
  '/auth/google/callback',
]);

export function isAuthPath(pathname: string): boolean {
  return AUTH_PATHS.has(pathname);
}

/** Écran public d’inscription à un webinaire live (hors salle immersive). */
export function isWebinarRegistrationPath(pathname: string): boolean {
  return pathname.startsWith('/webinars/register/');
}

/** True si la page actuelle est marketing, légale ou auth : une 401 ne doit pas imposer /login (jeton expiré). */
export function isPublicOrAuthPath(pathname: string): boolean {
  if (EXACT_PUBLIC_PATHS.has(pathname)) return true;
  if (pathname.startsWith('/blog/') || pathname.startsWith('/store/')) return true;
  if (pathname.startsWith('/s/') || pathname.startsWith('/c/')) return true;
  if (/^\/[A-Za-z0-9_-]{8,12}$/.test(pathname)) return true;
  if (/^\/f\/[^/]+(\/(checkout|merci))?$/.test(pathname)) return true;
  if (AUTH_PATHS.has(pathname)) return true;
  // Webinar public flow: login is handled inline on the page.
  if (pathname.startsWith('/webinars/live/')) return true;
  if (pathname.startsWith('/webinars/register/')) return true;
  if (pathname.startsWith('/podcasts/public') || pathname.startsWith('/podcasts/learner')) return true;
  if (pathname.startsWith('/deposit/')) return true;
  if (/^\/eduflow\/flows\/[^/]+\/public$/.test(pathname)) return true;
  if (pathname.startsWith('/eduflow/participant/')) return true;
  return false;
}
